import {
  ArchiveBook,
  Category,
  Cup,
  EmptyWallet,
  Home2,
  LocationDiscover,
  People,
  PresentionChart,
  Profile2User,
  Receipt1,
} from "iconsax-react";
import { IoEllipsisVerticalCircleOutline, IoNotificationsCircleSharp } from "react-icons/io5";
import { MdAnalytics } from "react-icons/md";

export const Navtab = [
  {
    id: 1,
    name: "dashboard",
    link: "/dashboard",
    isActiveIcon: <Home2 className="h-5 w-5" variant="Bold" />,
    icon: <Home2 className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
  {
    id: 2,
    name: "revenue",
    link: "/revenue",
    isActiveIcon: <EmptyWallet className="h-5 w-5" variant="Bold" />,
    icon: <EmptyWallet className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
  {
    id: 3,
    name: "subscription",
    link: "/subscriptions",
    isActiveIcon: <Receipt1 className="h-5 w-5" variant="Bold" />,
    icon: <Receipt1 className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
  {
    id: 4,
    name: "subscribers",
    link: "/subscribers",
    isActiveIcon: <Profile2User className="h-5 w-5" variant="Bold" />,
    icon: <Profile2User className="h-5 w-5" />,
    isDropdown: true,
    fields: [
      {
        name: "overall",
        link: "/subscribers/overall",
      },
      // {
      //   name: "churn",
      //   link: "/subscribers/churn",
      // },
    ],
  },
  {
    id: 5,
    name: "competitions",
    link: "/competitions",
    isActiveIcon: <Cup className="h-5 w-5" variant="Bold" />,
    icon: <Cup className="h-5 w-5" />,
    isDropdown: true,
    fields: [
      {
        name: "competition",
        link: "/competitions/competitions",
      },
      {
        name: "quiz",
        link: "/competitions/quiz",
      },
      {
        name: "winners-statistic",
        link: "/competitions/winners-statistic",
      },
    ],
  },
  {
    id: 6,
    name: "plans",
    link: "/plans",
    isActiveIcon: <Category className="h-5 w-5" variant="Bold" />,
    icon: <Category className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
  {
    id: 7,
    name: "sources",
    link: "/sources",
    isActiveIcon: <LocationDiscover className="h-5 w-5" variant="Bold" />,
    icon: <LocationDiscover className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
  {
    id: 8,
    name: "users",
    link: "/users",
    isActiveIcon: <People variant="Bold" />,
    icon: <People />,
    isDropdown: true,
    fields: [
      {
        name: "Users",
        link: "/users/users",
      },
      {
        name: "Roles",
        link: "/users/roles",
      },
      {
        name: "Permissions",
        link: "/users/permissions",
      },
    ],
  },
  // {
  //   id: 9,
  //   name: "analytics and reports",
  //   link: "/report",
  //   isActiveIcon: <PresentionChart className="h-5 w-5" variant="Bold" />,
  //   icon: <PresentionChart className="h-5 w-5" />,
  //   isDropdown: false,
  //   fields: [],
  // },
  {
    id: 10,
    name: "Analytics Overview",
    link: "/analytics-overview",
    isActiveIcon: <MdAnalytics className="h-5 w-5" />,
    icon: <MdAnalytics className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
  {
    id: 11,
    name: "Event Tracking",
    link: "/event-tracking",
    isActiveIcon: <IoEllipsisVerticalCircleOutline className="h-5 w-5" />,
    icon: <IoEllipsisVerticalCircleOutline className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
  {
    id: 12,
    name: "Notification Engine",
    link: "/notification-engine",
    isActiveIcon: <IoNotificationsCircleSharp className="h-5 w-5" />,
    icon: <IoNotificationsCircleSharp className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
  {
    id: 13, 
    name: "Settings",
    link: "/settings",
    isActiveIcon: <ArchiveBook className="h-5 w-5" variant="Bold" />,
    icon: <ArchiveBook className="h-5 w-5" />,
    isDropdown: false,
    fields: [],
  },
];
